import type { FunctionComponent } from 'react';

import { SkillDetailsAppDrawerContent } from '../skill-details/SkillDetails';
import { AppDrawer, useAppDrawer } from './AppDrawer';
import { drawerConf } from './constants';

export const AppDrawers: FunctionComponent = () => {
    const { currentDrawer } = useAppDrawer();
    const isSkillDetailsDrawer = currentDrawer === drawerConf.name;

    return <AppDrawer>{isSkillDetailsDrawer && <SkillDetailsAppDrawerContent />}</AppDrawer>;
};
